import React, { useState, useEffect, useCallback } from 'react';
import { Button, Alert, Spinner } from 'flowbite-react'; // Removed Pagination from import
import api from '../../../services/api/axiosConfig';
import {  HiPlus } from 'react-icons/hi';
import PageHeading from '../../../components/PageHeading';
import { useNavigate, Link } from 'react-router-dom';
import Breadcrumb from '../../dashboard/pages/components/BreadCrumb';
import API_ENDPOINTS from '../../../services/api/endpoints';
import { toast } from 'react-toastify';

const CustomerListingPage = () => {
    const navigate = useNavigate();

    // State for customer data and simplified pagination for next/previous
    const [customers, setCustomers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1); // Start from page 1
    const [hasMoreData, setHasMoreData] = useState(true); // Assume there are more pages initially
    const perPage = 2; 

    const breadcrumbItems = [
        { label: 'Dashboard', url: '/dashboard' },
        { label: 'Customers', url: '/dashboard/customer-list', current: true }
    ];

    // State for UI feedback
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);


    // State for search and filter
    const [searchTerm, setSearchTerm] = useState('');
    const [filterBy, setFilterBy] = useState('');
    const [currentSearchTerm, setCurrentSearchTerm] = useState('');

    // Debounce search term to prevent excessive API calls
    useEffect(() => {
        document.title = "CPA - Customer Listing";
        const handler = setTimeout(() => {
            setCurrentSearchTerm(searchTerm);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    // Function to fetch customers
    const fetchCustomers = useCallback(async () => {
        setLoading(true);
        setError(null);
        setSuccessMessage(null);

        try {
            const params = {
                page: currentPage,
                perPage: perPage,
                search: currentSearchTerm,
                filter_by: filterBy,
            };

            const response = await api.get(API_ENDPOINTS.PANEL.CUSTOMER.LISTING, { params });

            if (response.data && response.data.statuscode==201) {

                if(response.data.body && Array.isArray(response.data.body)) {
                    setCustomers(response.data.body);
                    setHasMoreData((response.data.body).length === perPage);


                }else {
                    setCustomers([]);

                    setHasMoreData(false);
                }

                // If the number of fetched customers is LESS THAN the 'perPage' limit,
                // it means we've reached the last page (or there are no more records).

            } else {
                setError(response.data.message || 'Received invalid data structure from the API.');
                setCustomers([]);
                setHasMoreData(false);
            }
        } catch (err) {
            if (err.response) {
                setError(err.response.data.message || `Error: ${err.response.status} - ${err.response.statusText}`);
            } else if (err.request) {
                setError('Network Error: No response from server. Please check your connection.');
            } else {
                setError('An unexpected error occurred during API request.');
            }
            console.error('Error fetching customers:', err);
            setCustomers([]);
            setHasMoreData(false);
        } finally {
            setLoading(false);
        }
    }, [currentPage, perPage, currentSearchTerm, filterBy]);

    // Fetch customers on currentPage, currentSearchTerm, filterBy changes
    useEffect(() => {
        fetchCustomers();
    }, [fetchCustomers]);

    // Handle "Next" page
    const handleNextPage = () => {
        if (hasMoreData && !loading) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    // Handle "Previous" page
    const handlePreviousPage = () => {
        if (currentPage > 1 && !loading) {
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };

    // Handle Search form submission
    const handleSearchSubmit = (e) => {
        e.preventDefault();
        setCurrentPage(1); // Reset to first page on new search
        // No need to set currentSearchTerm here, it's already debounced by useEffect
    };

    // Handle navigation to Add Customer page
    const handleAddCustomerClick = () => {
        navigate('/dashboard/create-customer');
    };

 


    return (
        <div className="p-4 sm:p-6 lg:p-8">
            <Breadcrumb items={breadcrumbItems} />

            <PageHeading value="Customer Listing" />

            {/* Error Display */}
            {error && (
                <Alert color="failure" onDismiss={() => setError(null)} className="mb-4">
                    <span className="font-medium">Error!</span> {error}
                </Alert>
            )}

            {/* Success Message Display */}
            {successMessage && (
                <Alert color="success" onDismiss={() => setSuccessMessage(null)} className="mb-4">
                    <span className="font-medium">Success!</span> {successMessage}
                </Alert>
            )}
            <div className="flex justify-end items-center mb-6">
                <Button onClick={handleAddCustomerClick} className="bg-primary-brand text-white hover:bg-primary-brand-darker focus:ring-4 focus:ring-primary-brand/50 rounded-lg">
                    <HiPlus className="mr-2 h-5 w-5" />
                    Add Customer
                </Button>
            </div>

            {/* Search and Filter Section */}
            {/* <div className="mb-6">
                <form onSubmit={handleSearchSubmit} className="flex flex-col md:flex-row gap-4 items-end">
                    <div className="flex-1 w-full">
                        <TextInput
                            id="search"
                            type="text"
                            icon={HiOutlineSearch}
                            placeholder={`Search by ${filterBy.replace('_', ' ')}...`}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full"
                        />
                    </div>
                    <div className="w-full md:w-auto">
                        <select
                            id="filterBy"
                            value={filterBy}
                            onChange={(e) => setFilterBy(e.target.value)}
                            className="block w-full p-2.5 border border-gray-300 rounded-lg bg-gray-50 text-sm focus:ring-primary-brand focus:border-primary-brand dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-brand dark:focus:border-primary-brand"
                        >
                            <option value="">Filter by</option>
                            <option value="FirstName">First Name</option>
                            <option value="LastName">Last Name</option>
                            <option value="Email">Email</option>
                            <option value="Phone">Phone</option>
                        </select>
                    </div>
                </form>
            </div> */}

            {/* Loading Spinner */}
            {loading ? (
                <div className="flex justify-center items-center h-64">
                    <Spinner size="xl" />
                </div>
            ) : (
                <div className="overflow-x-auto ">
                    {customers.length > 0 ? (
                        <table className="w-full text-sm text-left rtl:text-right">
                            <thead className="text-xs uppercase bg-gray-100">
                                <tr>
                                    <th scope="col" className="px-6 py-3">Full Name</th>
                                    <th scope="col" className="px-6 py-3">Email</th>
                                    <th scope="col" className="px-6 py-3">Phone</th>
                                </tr>
                            </thead>
                            <tbody>
                                {customers.map((customer, index) => (
                                    <tr
                                        key={customer.CustomerGuid}
                                        className={`
                                            ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                                            border-b dark:border-gray-700
                                            hover:bg-gray-100
                                        `}
                                    >
                                        <td className="px-6 py-4">
                                            <Link to={`/dashboard/customer/${customer.CustomerGuid}`} className="hover:underline">
                                                {customer.FirstName} {customer.LastName}
                                            </Link>
                                        </td>
                                        <td className="px-6 py-4">{customer.Email}</td>
                                        <td className="px-6 py-4">{customer.Phone}</td>

                                       
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className="text-center py-8 text-gray-500 dark:text-gray-400">
                            No customers found.
                        </div>
                    )}
                </div>
            )}

            {/* Pagination: Explicit Next and Previous Buttons */}
            <div className="flex justify-between items-center mt-6">
                <Button
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1 || loading}
                    className="bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Previous
                </Button>
                <Button
                    onClick={handleNextPage}
                    disabled={!hasMoreData || loading}
                    className="bg-primary-brand text-white hover:bg-primary-brand-darker disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Next
                </Button>
            </div>

            {/* Removed the extra pagination info text as it no longer makes sense without total count from API */}
            {/* If you absolutely need it, you'd need to estimate total or fetch it separately */}
            {/* <div className="text-center mt-2 text-sm text-gray-600 dark:text-gray-400">
                Showing {pagination.from} to {pagination.to} of {pagination.total} entries
            </div> */}

        </div>
    );
};

export default CustomerListingPage;